var _defs, _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCopp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.9 298.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #f15a22;\n      }\n\n      .cls-3 {\n        fill: #008d9b;\n      }\n\n      .cls-4 {\n        fill: #034ea2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 149.45,
    cy: 149.45,
    r: 149.45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "236.72 63.51 224.12 75.17 225.53 76.69 231.43 71.23 235.82 75.97 237.18 74.7 232.79 69.97 236.76 66.29 241.62 71.53 242.99 70.27 236.72 63.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.24,42.93c-4.4-2.52-9.76-1.13-12.21,3.15-2.45,4.28-.92,9.61,3.48,12.13,4.42,2.53,9.81,1.16,12.26-3.12,2.45-4.28.91-9.62-3.52-12.15Zm-7.72,13.58c-1.65-.95-2.83-2.44-3.31-4.2-.47-1.73-.23-3.56.69-5.16,1.9-3.32,6.03-4.41,9.39-2.49,3.34,1.91,4.48,6.01,2.58,9.33-.92,1.61-2.38,2.76-4.11,3.23-1.74.47-3.61.22-5.24-.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.29 26.94 147.15 33.31 141.74 27.15 139.16 27.2 146.14 35.2 146.32 44.24 148.39 44.2 148.21 35.16 154.87 26.89 152.29 26.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.24 30.84 104.59 35.29 105.17 37.06 111.01 35.15 115.76 49.7 117.73 49.06 112.98 34.51 118.82 32.6 118.24 30.84"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.66,
    y: 45.22,
    width: 2.07,
    height: 17.17,
    transform: "translate(-15.16 56.24) rotate(-32.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.68,70.76l-.16.64c-.6,2.38-1.37,3.96-2.56,5.29-2.72,3.03-6.7,3.28-9.68.6-2.9-2.61-3.15-6.73-.58-9.6,1.25-1.39,2.81-2.4,4.92-3.17l.62-.23-1.72-1.55-.24.1c-2.05.89-3.74,2.06-5,3.47-1.62,1.81-2.48,4.21-2.35,6.59.12,2.29,1.16,4.42,2.91,6,1.76,1.58,3.98,2.39,6.24,2.27,2.38-.13,4.65-1.26,6.37-3.18,1.32-1.47,2.3-3.38,2.83-5.52l.06-.23-1.65-1.49Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.98,126.01c-2.49-.61-3.99-3.09-3.38-5.57.61-2.49,3.09-3.99,5.57-3.38,2.49.61,3.99,3.09,3.38,5.57-.61,2.49-3.09,3.99-5.57,3.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m48.14,180.17c1.36,4.8-1.38,7.91-4.25,8.72-2.96.84-6.94-.3-8.31-5.13l-1.18-4.16-8.44,2.39-1.48-5.23,21-5.95,2.65,9.36Zm-9.88-1.66l.69,2.43c.68,2.4,1.79,3.02,3.36,2.57,1.79-.51,2.14-1.71,1.34-4.54l-.52-1.85-4.87,1.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.58,215.03c-4.11-6.87-1.59-13.63,3.19-16.49,4.53-2.71,11.81-2.07,16.03,4.99,4.22,7.06,1.29,13.77-3.21,16.46-4.81,2.87-11.99,1.76-16.02-4.97Zm15.33-9.16c-2.13-3.57-5.83-4.57-9.26-2.52-3.43,2.05-4.3,5.78-2.17,9.35,2.12,3.54,5.81,4.54,9.24,2.49,3.43-2.05,4.3-5.78,2.18-9.32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m77.57,227.13c3.25,3.08,3.1,7.1.86,9.46-1.65,1.74-3.79,2.18-6.39,1.3.85,2.35-.51,4.77-2.69,11.52l-4.34-4.12c1.52-5,3.78-8.63,1.65-10.66l-1.14-1.08-6.1,6.43-3.95-3.75,15.03-15.83,7.08,6.72Zm-9.3,3.52l2.09,1.98c1.09,1.04,2.6,1.58,3.88.24,1.12-1.18.93-2.51-.55-3.92l-2-1.89-3.42,3.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m105.94,250.88l-6.93-3.81-8.58,15.62-4.77-2.62,8.58-15.62-6.93-3.81,1.93-3.51,18.62,10.23-1.93,3.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m142.38,255.06c4.98.42,6.92,4.08,6.67,7.05-.26,3.06-2.72,6.39-7.73,5.97l-4.31-.36-.73,8.74-5.42-.45,1.82-21.75,9.69.81Zm-5.03,8.67l2.52.21c2.49.21,3.46-.61,3.59-2.24.15-1.85-.84-2.61-3.78-2.85l-1.91-.16-.42,5.04Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m185.26,272.49l-5.34,1.07-1.73-8.66-10.67,2.13,1.73,8.66-5.34,1.07-4.28-21.41,5.34-1.07,1.72,8.6,10.67-2.13-1.72-8.6,5.34-1.07,4.28,21.41Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m206.82,263.55l-4.91,2.34-9.4-19.7,4.91-2.34,9.4,19.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m235.78,243.93l-13.05,10.31-13.53-17.12,4.27-3.37,11.05,13.98,8.79-6.94,2.48,3.14Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m255.03,221.81l-10.38,13-17.06-13.61,3.39-4.25,13.93,11.12,6.99-8.75,3.13,2.49Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m263.45,207.02l-2.56,4.8-19.26-10.27,2.56-4.8,19.26,10.27Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m251.81,176.49c1.36-4.8,5.33-6.01,8.19-5.2,2.96.84,5.75,3.89,4.38,8.72l-1.18,4.16,8.44,2.39-1.48,5.23-21-5.94,2.65-9.36Zm7.55,6.59l.69-2.43c.68-2.4.06-3.51-1.51-3.95-1.79-.51-2.72.33-3.52,3.16l-.52,1.85,4.87,1.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m261.76,117.06c2.49-.61,4.96.89,5.57,3.38.61,2.49-.89,4.96-3.38,5.57-2.49.61-4.96-.89-5.57-3.38-.61-2.49.89-4.96,3.38-5.57Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.67,177.12c-18.05-3.98-30.21-35.81-72.17-18.01-.38-3.28-.49-6.31-.49-9.69,0-39.98,27.14-73.6,64-83.49,3.28,2.54,6.81,6.55,6,14.28-20.2-.52-27.29,8.57-27.29,8.57,0,0,12.46,1.55,15.92,5.01-22.47,1.07-23.81,21.94-23.81,21.94,0,0,16.32-12.54,27.16-8.03-17.33,4.3-18.33,20.87-18.33,20.87,0,0,12.43-12.72,22.06-9.54-14.57,11.95-8.91,27.6-8.91,27.6,6.67-15.24,14.2-18.07,15.43-14.27-5.53,13.85,1.67,23.08.44,44.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m68.78,180.52c12.49,32.38,43.89,55.36,80.67,55.36,41.54,0,76.22-29.3,84.54-68.36l-11.94-9.57-18.21,14.6-18.21-14.6-18.29,14.66-17.89-15.29v48.82c-41.22,0-48.5-42.38-80.67-25.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.54,121.44c-11.1,11.1-13.24,25.23-13.24,25.23,0,0,8.61-3.16,16.49.34,0,0-5.22-4.82-3.25-25.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 164.08,
    cy: 200.9,
    r: 3.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.35,204.81c2.16,0,3.91-1.75,3.91-3.91s-1.75-3.91-3.91-3.91-3.91,1.75-3.91,3.91,1.75,3.91,3.91,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m200.63,204.81c2.16,0,3.91-1.75,3.91-3.91s-1.75-3.91-3.91-3.91-3.91,1.75-3.91,3.91,1.75,3.91,3.91,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m143.78,187.15c-30.32.19-37.32-40-79.04-20.39.77,3.98,1.58,6.46,1.58,6.46,36.3-16.74,45.06,20.97,77.46,25.04v-11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.17,139.2v-16.48l-15.65.02v-16.39h-15.9v-7.23h29.14c-15.69-21.88-41.33-36.14-70.31-36.14-6.9,0-13.59.83-20.02,2.36,6.38,1.97,13.33,3.44,17.31,13.58,17.16-8.13,28.59.9,28.59.9,0,0-15.85,3.01-16.39,11.04,17.93-5.89,23.41,7.63,23.41,7.63,0,0-15.41-3.83-20.07,4.41,16.05,1.61,18.46,17.26,18.46,17.26,0,0-14.15-9.83-24.08-1.6,19.26,6.02,16.86,23.14,16.86,23.14,0,0-17.35-19.04-23.32-8.88,1.7,7.37.98,15.32.98,15.32l16.32,13.95,18.13-14.53,18.21,14.6,18.21-14.6,13.4,10.74c.3-2.91.45-5.86.45-8.85,0-3.46-.21-6.87-.61-10.23h-13.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 190.66,
    y: 115.92,
    width: 6.32,
    height: 6.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.66,
    y: 132.41,
    width: 6.32,
    height: 6.77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCopp);
export default __webpack_public_path__ + "static/media/logo-copp.de53c5cf513f53d8c21b66e152c342f1.svg";
export { ForwardRef as ReactComponent };